<div class="one-row" style="margin: 12px">
    <button mat-stroked-button color="accent" (click)="aktualisieren()">
        <mat-icon>refresh</mat-icon>
        Aktualisieren
    </button>
    <button (click)="direktBelegErstellen()" color="accent" mat-stroked-button style="margin-left: 12px">
        <mat-icon>present_to_all</mat-icon>
        Direktbeleg
    </button>
    <span class="spacer"></span>
</div>
<div class="one-row">
    <div class="card">
        <div class="column">
            <div class="card-header-sticky">
                <mat-icon (click)="openDayPickerDialog()" style="cursor: pointer">today</mat-icon>
                <span class="spacer"></span>
                <button (click)="previousDay()" mat-icon-button>
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <span style="cursor: pointer" (click)="openDayPickerDialog()"
                    >Geplant {{ plannedDay | date: "dd.MM.YYYY" }} ({{ plannedData?.length || 0 }})</span
                >
                <button (click)="nextDay()" mat-icon-button>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <span class="spacer"></span>
                <button mat-icon-button (click)="addEntry()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <mat-list>
                <p
                    *ngIf="!loadPlanned && plannedData?.length === 0"
                    style="width: 100%; text-align: center; font-weight: bold"
                    >Keine Einträge vorhanden</p
                >
                <p *ngIf="loadPlanned" style="width: 100%; text-align: center; font-weight: bold"
                    >Einträge werden geladen...
                </p>
                <mat-list-item *ngFor="let item of plannedData">
                    <!-- Hamburger-Menü -->
                    <button mat-icon-button [matMenuTriggerFor]="menu1" color="accent">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu1="matMenu">
                        <button mat-menu-item *kienePermission="[7002]" (click)="changeToWartezimmer(item)">
                            <mat-icon>airline_seat_recline_extra</mat-icon>
                            <span>Im Wartezimmer</span>
                        </button>
                        <button mat-menu-item *kienePermission="[7002]" (click)="editEntry(item)">
                            <mat-icon>edit</mat-icon>
                            <span>Kalendereintrag editieren</span>
                        </button>
                        <button mat-menu-item *kienePermission="[7004]" (click)="onDelete(item)">
                            <mat-icon>delete</mat-icon>
                            <span>Kalendereintrag löschen</span>
                        </button>
                    </mat-menu>
                    <div class="item-content" (click)="changeToWartezimmer(item)">
                        <h4 mat-line>{{ item.kunde }} {{ getTiernamen(item) }}</h4>
                        <p mat-line>{{ item?.von | date: "HH:mm" }}: {{ item.titel }}</p>
                    </div>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
    <div class="card">
        <div class="column">
            <div class="card-header-sticky">
                <mat-icon>airline_seat_recline_extra</mat-icon>
                <span>Im Wartezimmer ({{ waitingRoomData?.length || 0 }})</span>
                <span class="spacer"></span>
            </div>
            <mat-list>
                <p *ngIf="waitingRoomData?.length === 0" style="width: 100%; text-align: center; font-weight: bold">
                    Keine Einträge vorhanden</p
                >
                <mat-list-item *ngFor="let item of waitingRoomData">
                    <!-- Hamburger-Menü -->
                    <button mat-icon-button [matMenuTriggerFor]="menu2" color="accent">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu2="matMenu">
                        <button mat-menu-item (click)="changeToBehandlung(item)">
                            <mat-icon>medication</mat-icon>
                            <span>In Behandlung</span>
                        </button>
                    </mat-menu>
                    <div class="item-content" (click)="changeToBehandlung(item)">
                        <h4 mat-line>{{ item.kunde }} {{ getTiernamen(item) }}</h4>
                        <p mat-line
                            >seit {{ item?.wartezimmer_seit | date: "HH:mm" }} . {{ item.notiz?.substring(0, 70) }}</p
                        >
                    </div>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
    <div class="card">
        <div class="column">
            <div class="card-header-sticky">
                <mat-icon>medication</mat-icon>
                <span>In Behandlung ({{ inTreatmentData?.length || 0 }})</span>
                <span class="spacer"></span>
            </div>
            <mat-list>
                <p *ngIf="inTreatmentData?.length === 0" style="width: 100%; text-align: center; font-weight: bold">
                    Keine Einträge vorhanden</p
                >
                <mat-list-item *ngFor="let item of inTreatmentData">
                    <!-- Hamburger-Menü -->
                    <button mat-icon-button [matMenuTriggerFor]="menu3" color="accent">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu3="matMenu">
                        <button mat-menu-item (click)="gotoBeleg(item)">
                            <mat-icon>description</mat-icon>
                            <span>Beleg anzeigen</span>
                        </button>
                        <button mat-menu-item (click)="changeBackToWartezimmer(item)">
                            <mat-icon>keyboard_return</mat-icon>
                            <span>Zur&uuml;ck ins Wartezimmer</span>
                        </button>
                        <button mat-menu-item (click)="changeToBehandlung(item)">
                            <mat-icon>compare_arrows</mat-icon>
                            <span>In Behandlungsraum wechseln</span>
                        </button>
                    </mat-menu>
                    <div class="item-content" (click)="gotoBeleg(item)">
                        <h4 mat-line>{{ item.kunde }} {{ getTiernamen(item) }}</h4>
                        <p mat-line>
                            In Behandlung seit: {{ item?.behandlung_seit | date: "HH:mm" }}
                            {{ item?.behandlungsraum ? " in " + item?.behandlungsraum : "" }}
                        </p>
                    </div>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
    <div class="card">
        <div class="column">
            <div class="card-header-sticky">
                <mat-icon>credit_card</mat-icon>
                <span>Fertig und Abrechnen ({{ readyForPaymentData?.length || 0 }})</span>
                <span class="spacer"></span>
            </div>
            <mat-list>
                <p *ngIf="readyForPaymentData?.length === 0" style="width: 100%; text-align: center; font-weight: bold">
                    Keine Einträge vorhanden</p
                >
                <mat-list-item *ngFor="let item of readyForPaymentData">
                    <!-- Hamburger-Menü -->
                    <button mat-icon-button [matMenuTriggerFor]="menu4" color="accent">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu4="matMenu">
                        <button mat-menu-item (click)="gotoBeleg(item)">
                            <mat-icon>description</mat-icon>
                            <span>Beleg anzeigen/editieren</span>
                        </button>
                        <button (click)="rechnungErstellen(item)" mat-menu-item>
                            <mat-icon>credit_card</mat-icon>
                            <span>Rechnung erstellen</span>
                        </button>
                    </mat-menu>
                    <div (click)="gotoBeleg(item)" class="item-content">
                        <h4 mat-line>{{ item.kunde }} {{ getTiernamen(item) }}</h4>
                        <p mat-line>Beleg {{ item.beleg_nr }}</p>
                    </div>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
</div>
